var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlinebanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.99 69.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #008600;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.62,
    y1: 68.36,
    x2: 68.36,
    y2: 68.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.36,20.69H1.62L32.42,2.38c1.57-1.01,3.58-1.01,5.15,0l30.79,18.31Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "63.59 30.23 63.59 58.83 54.06 58.83 54.06 30.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.76 30.23 39.76 58.83 30.23 58.83 30.23 30.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "15.93 30.23 15.93 58.83 6.39 58.83 6.39 30.23"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinebanking);
export default __webpack_public_path__ + "static/media/online banking.32091921b096b5d6080b14a3bdfe4c9e.svg";
export { ForwardRef as ReactComponent };